import { useTranslation } from 'react-i18next';
import { ReturnToBusinessLocationsButton } from './ReturnToBusinessLocationsButton';
import { AccountSetupStepCounter } from '../../../framework';
import React from 'react';
import styled from 'styled-components';
import { StorageKeys, StorageService } from 'lib/StorageService';
import { maskEmail } from 'shared/utils/utils';
import PearlConnect from 'assets/PlannerImages/pearl-connect.svg';
import { ReactComponent as PearlAnnouncementLogo } from 'assets/PlannerImages/pearl-logo.svg';

const NewVendorWebstoreSetupHeader = (props) => {
    const {
        onReturnToBusinessLocations,
        stepName,
        currentStepCount,
        totalSteps,
        hideStepCount,
        hideStepName,
        showSubTitle,
        showMobileTopBar,
        announcementText,
    } = props;

    const { t } = useTranslation();
    const stepTns = t(`Forms.${stepName}`, { returnObjects: true });
    const storageService = StorageService();
    const cybInProgress = JSON.parse(storageService?.get(StorageKeys.cybInProgressWebstore));

    const DynamicTextWrapper = styled.span`
        color: #132122;
        font-family: 'Objektiv Mk2 Bold';
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: 21px;
    `;

    const MobileTopBar = styled.div`
        display: flex;
        align-items: center;
        justify-content: center;
        border-top: 1px solid #d0d4d5;
        border-bottom: 1px solid #d0d4d5;
        padding: 12px 16px;
        margin: -8px -16px 12px;
        background: #ffffff;
        min-height: 30px;

        .logo {
            width: 140px;
            height: auto;
            display: block;
        }

        @media (min-width: 816px) {
            padding: 12px 32px;
            margin: -4px -48px 12px;
            min-height: 62px;

            .logo {
                width: 140px;
                height: auto;
            }
        }
    `;

    const AnnouncementBanner = styled.div`
        display: flex;
        align-items: flex-start;
        gap: 10px;
        padding: 12px 16px;
        border-radius: 8px;
        border: 1px solid #e8eeef;
        background: #f5f8f8;
        margin-bottom: 22px;

        .announcementIcon {
            display: inline-flex;
            width: 16px;
            height: 16px;
            align-items: center;
            justify-content: center;
            margin-top: 2px;
            flex-shrink: 0;

            svg {
                display: block;
                width: 16px;
                height: 16px;
            }
        }

        .announcementText {
            color: #132122;
            font-family: 'Objektiv Mk2';
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px;
        }
    `;

    return (
        <>
            {showMobileTopBar && (
                <MobileTopBar className="mobileTopBar">
                    <img className="logo" src={PearlConnect} alt={t('DavidsBridalLogoAlt')} />
                </MobileTopBar>
            )}
            <div className="actions">
                {!!onReturnToBusinessLocations && (
                    <ReturnToBusinessLocationsButton onClick={onReturnToBusinessLocations} />
                )}
            </div>
            {announcementText && (
                <AnnouncementBanner role="status" aria-live="polite">
                    <span className="announcementIcon" aria-hidden="true">
                        <PearlAnnouncementLogo />
                    </span>
                    <span className="announcementText">{announcementText}</span>
                </AnnouncementBanner>
            )}
            <AccountSetupStepCounter
                stepCountText={`STEP ${t('Forms.Labels.Steps', {
                    completedSteps: currentStepCount,
                    totalSteps: totalSteps,
                })}`}
                stepNameText={hideStepName ? '' : stepTns.StepName}
                hideStepCount={hideStepCount}
            />
            <h1 className="title">{stepTns.Title}</h1>
            <p className="subtitle">
                {showSubTitle && cybInProgress?.IsCYB ? (
                    <>
                        {t('Forms.BasicDetails.DynamicSubTitle1')}{' '}
                        <DynamicTextWrapper>
                            <b>{maskEmail(cybInProgress?.CybContactEmail)}</b>
                        </DynamicTextWrapper>{' '}
                        {t('Forms.BasicDetails.DynamicSubTitle2')}
                    </>
                ) : (
                    stepTns.Subtitle
                )}
            </p>
            {!!stepTns.Requirement && (
                <div className="stepInstructions">
                    <label className="cta">
                        <b>{stepTns.Requirement}</b>
                    </label>
                </div>
            )}
        </>
    );
};

export { NewVendorWebstoreSetupHeader };
